import type { ObjectiveId } from '@contracts';
import { useIsDesktopViewport } from '@ui/shared/viewport/useIsDesktopViewport';
import { WeeklyReviewScreenDesktop } from '@ui/desktop/weekly-review/WeeklyReviewScreen.desktop';
import { WeeklyReviewScreenPhone } from '@ui/phone/weekly-review/WeeklyReviewScreen.phone';

/**
 * `WeeklyReviewScreen` — the switch component (design/screens/responsive-strategy.md
 * §2.2), the sibling of `@ui/rewards/RewardsScreen`. The ONLY Weekly Review
 * import `App.tsx` uses. Picks the phone- or desktop-shaped tree at runtime
 * via `useIsDesktopViewport()` — fixes the same class of severity-1 bug as
 * Rewards (six-panel desktop composition, incl. a 6-column habits table,
 * rendered unadapted at ~390px via the phone Today view's `Week` footer
 * link). See desktop-weekly-review.md §9 for the phone tree's exact spec.
 */
export function WeeklyReviewScreen({
  onBack,
  onEditObjective,
}: {
  readonly onBack: () => void;
  readonly onEditObjective: (objectiveId: ObjectiveId) => void;
}) {
  const isDesktop = useIsDesktopViewport();
  return isDesktop ? (
    <WeeklyReviewScreenDesktop onBack={onBack} onEditObjective={onEditObjective} />
  ) : (
    <WeeklyReviewScreenPhone onBack={onBack} onEditObjective={onEditObjective} />
  );
}
